import { useParams } from "react-router-dom";
import { ContactDetails } from "@/features/person/components/ContactDetails";
import { CardSkeleton } from "@/components/Skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";
import { usePersonContactDetailsQuery } from "./_usePersonContactDetailsQuery";

export default function PersonDetails() {
  const { pgaId } = useParams();
  const { loaded, canViewPersonContact, person, error } = usePersonContactDetailsQuery(pgaId);

  if (!loaded || !canViewPersonContact) {
    return null;
  }

  if (error) {
    return (
      <ErrorBoundary variant="inline" title="Failed to Load Person Details" message={error.message} className="mt-12" />
    );
  }

  if (!person) {
    return (
      <div className="flex mt-4 gap-4">
        <CardSkeleton maxWidth={60} />
        <CardSkeleton maxWidth={60} />
      </div>
    );
  }

  return (
    <div>
      <ContactDetails person={person} />
    </div>
  );
}
